// extracted by mini-css-extract-plugin
export var banner = "exercises-module--banner--ded3f";
export var list = "exercises-module--list--b7d0b";